import Vue from 'vue'
import VueRx from 'vue-rx'

import 'jquery/src/jquery.js'
import 'jquery-ui-dist/jquery-ui'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'popper.js/dist/popper.js'
import 'select2/dist/js/select2.min.js'
import 'jquery.nicescroll/dist/jquery.nicescroll.min.js'
import 'emojionearea/dist/emojionearea.min.js'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'izitoast/dist/css/iziToast.min.css'
import 'select2/dist/css/select2.min.css'
import 'dropzone/dist/min/dropzone.min.css'
import 'emojionearea/dist/emojionearea.min.css'

import '../../assets/vendor/stisla/style.css'
import '../../assets/modified.css'
import '../../assets/style.css'

import $ from 'jquery'
window.jQuery = window.$ = $

Vue.use(VueRx)